module.exports = __webpack_public_path__ + "static/media/012-teeth cleaning.005fa082.svg";